import React from "react";
import classNames from "classnames";
import { view } from "react-easy-state";
import InputText from "./InputText";
import {
  impSValidation,
  impYValidation,
  impYValidationEl,
  genTextValidation,
} from "../utils/validators";
import { withTranslation } from "react-i18next";

const PrestImpInput = ({
  prestazione,
  showContinuaBtn,
  onUpdate,
  onClickContinua,
  t,
}) => {
  const continuaBtnClasses = classNames({
    "kfpr-input": true,
    "kfpr-textarea": true,
    "kfpr-row-btn": true,
    "kfpr-inactive": !showContinuaBtn,
  });

  const maybeClickContinua = () => {
    if (showContinuaBtn) {
      onClickContinua();
    }
  };

  const popupValueAsBoolean = () => {
    const popupRawValue = prestazione.get("popup");

    if (typeof popupRawValue === "undefined") return false;
    if (popupRawValue === null) return false;
    if (popupRawValue === false) return false;
    if (Array.isArray(popupRawValue) && popupRawValue.length === 0)
      return false;

    console.log("isnuke", popupRawValue);
    return true;
  };

  return (
    <div className="kfpr-content kfpr-content-imp kfpr-content-imp-carta">
      {prestazione.get("impTipo") === "IC" && (
        <div className="kfpr-row kfpr-row-input kfpr-3input-ina-row">
          <InputText
            label="S"
            value={prestazione.get("impS") || ""}
            isMandatory
            ph={t("Codice dopo S")}
            onUpdate={onUpdate}
            validateFn={impSValidation}
            name="impS"
          />

          <InputText
            label="Y"
            value={prestazione.get("impY") || ""}
            isMandatory
            ph={t("Codice dopo Y")}
            onUpdate={onUpdate}
            validateFn={impYValidation}
            name="impY"
          />

          <div className="kfpr-input kfpr-input-info">
            <img
              alt=""
              className="kfpr-input-info-arrow"
              src="/wp-content/uploads/2019/06/bg-input-info-arrow-left.png"
            />

            <div
              role="button"
              className="as-a"
              data-featherlight="<div><img src='/wp-content/uploads/2019/03/impegnativa-facsimile.jpg' /></div>"
            >
              <img
                alt=""
                src="/wp-content/uploads/2019/03/ico-info.png"
              />
            </div>
            <span>{t("CODICE IMPEGNATIVA")}</span>
          </div>
          {popupValueAsBoolean() === true && (
            <InputText
              label="Peso"
              value={prestazione.get("peso") || ""}
              ph={t("kg")}
              onUpdate={onUpdate}
              validateFn={genTextValidation}
              extraContClass={"peso"}
              name="peso"
            />
          )}

          {popupValueAsBoolean() === true && (
            <InputText
              label="Altezza"
              value={prestazione.get("altezza") || ""}
              ph={t("cm")}
              onUpdate={onUpdate}
              validateFn={genTextValidation}
              extraContClass={"altezza"}
              name="altezza"
            />
          )}
        </div>
      )}

      {prestazione.get("impTipo") === "RE" && (
        <div className="kfpr-row kfpr-row-input kfpr-3input-ina-row">
          <div className="kfpr-input">
            <label>
              <span className="kf-orange-txt">*</span>
              {t("NUMERO RICETTA ELETTRONICA")}
            </label>
          </div>

          <InputText
            label=""
            value={prestazione.get("impY") || ""}
            ph="Codice"
            onUpdate={onUpdate}
            validateFn={impYValidationEl}
            name="impY"
          />

          <div className="kfpr-input kfpr-input-info">
            <img
              alt=""
              className="kfpr-input-info-arrow"
              src="/wp-content/uploads/2019/06/bg-input-info-arrow-left.png"
            />
            <div
              role="button"
              className="as-a"
              data-featherlight="<div><img src='/wp-content/uploads/2019/03/ricetta-elettronica-facsimile.jpg' /></div>"
            >
              <img
                alt=""
                src="/wp-content/uploads/2019/03/ico-info.png"
              />
            </div>
            <span>{t("NUMERO RICETTA")}</span>
          </div>

          {popupValueAsBoolean() === true && (
            <InputText
              label="Peso"
              value={prestazione.get("peso") || ""}
              ph={t("kg")}
              onUpdate={onUpdate}
              validateFn={genTextValidation}
              extraContClass={"peso"}
              name="peso"
            />
          )}

          {popupValueAsBoolean() === true && (
            <InputText
              label="Altezza"
              value={prestazione.get("altezza") || ""}
              ph={t("cm")}
              onUpdate={onUpdate}
              validateFn={genTextValidation}
              extraContClass={"altezza"}
              name="altezza"
            />
          )}
        </div>
      )}
      <div className="kfpr-row kfpr-row-input">
        <div className={continuaBtnClasses}>
          <label>{t("Motivo della Visita e Informazioni Aggiuntive")}</label>
          <textarea
            onChange={onUpdate}
            name="impMotivo"
            cols="40"
            rows="10"
            className="wpcf7-form-control wpcf7-textarea"
            aria-invalid="false"
          >
            {prestazione.get("impMotivo")}
          </textarea>
          <div
            role="button"
            className="button medium orange"
            onClick={maybeClickContinua}
          >
            {t("Continua")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(view(PrestImpInput));
